import React, { useEffect, useState, useMemo } from "react";
import { Tabel, Badge, DropDownMenu, DropDown, Loading, Section } from "../../core";
import { Link } from "react-router-dom";
import { Menu } from "antd";
import { getCompanyYarnHistory } from "../../helper/utils/api/yarnIssuence";
import { getCompanyId } from "../../helper/utils/companyId";
import {
  deleteYarnReceived,
  deleteYarnReturn,
} from "../../helper/utils/api/yarnIssuence";

const CHANGE_DATE_FORMAT = require("../../helper/utils/datFormat");

const MenuCompo = ({ record, onDeleted }) => {
  const handleDelete = async () => {
    try {
      if (record.recordType === "return") {
        await deleteYarnReturn(record._id);
      } else {
        await deleteYarnReceived(record._id);
      }
      if (onDeleted) onDeleted();
    } catch (error) {
      console.log("delete yarn error", error);
    }
  };

  return (
    <DropDownMenu>
      <Menu.Item onClick={handleDelete}>Delete</Menu.Item>
      <Menu.Item>
        <Link
          to={{
            pathname: `/contract-inner/${record.contract_no}`,
            state: record.contract_id,
          }}
        >
          View Contract
        </Link>
      </Menu.Item>
    </DropDownMenu>
  );
};

const YarnHistory = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadData = async () => {
    const companyId = getCompanyId();
    if (!companyId) return;
    setIsLoading(true);
    try {
      const { data } = await getCompanyYarnHistory(companyId);
      setRows(data?.result || []);
    } catch (error) {
      console.log("yarn history error", error);
      setRows([]);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const columns = useMemo(
    () => [
      {
        title: "SR #",
        dataIndex: "SNo",
        key: "S.No",
        width: 150,
      },
      {
        title: "Contract #",
        dataIndex: "contract_no",
        key: "contract_no",
        width: 150,
      },
      {
        title: "Date",
        dataIndex: "date",
        render: (text, record) => (
          <span>{CHANGE_DATE_FORMAT.changeDateFormat(record.date)}</span>
        ),
        key: "date",
        width: 150,
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 150,
      },
      {
        title: "Quality",
        dataIndex: "quality",
        key: "quality",
        width: 150,
      },
      {
        title: "Do #",
        dataIndex: "donumber",
        key: "donumber",
        width: 150,
      },
      {
        title: "Place",
        dataIndex: "Place",
        key: "Place",
        width: 150,
      },
      {
        title: "Freight",
        dataIndex: "feright",
        key: "feright",
        width: 150,
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 150,
        render: (text) => <Badge status={text} text={text} />,
      },
      {
        title: "",
        dataIndex: "action",
        width: 150,
        render: (text, record) => (
          <DropDown
            overlay={<MenuCompo record={record} onDeleted={loadData} />}
            record={record}
          />
        ),
      },
    ],
    []
  );

  return (
    <Section padding="20px" className="mt-20">
      {isLoading ? <Loading /> : null}
      <Tabel columns={columns} data={rows} rowKey="_id" />
    </Section>
  );
};

export default YarnHistory;
